// extracted by mini-css-extract-plugin
export var columnList = "_bm-0";